import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { blogs } from "../constants/blogsData";
import { Undo2 } from "lucide-react";
import "../styles/blogDetails.css";

const BlogDetails = () => {
	// const [isValidID, setIsValidID] = useState(false)
	const { id } = useParams();
	const navigate = useNavigate();

	// Find the blog with the matching ID
	const blogItem = blogs.find((blog) => String(blog.id) === String(id));

	// Check if blog exists
	const isValidID = Boolean(blogItem);

	useEffect(() => {
		if (!isValidID) {
			navigate("/blogs/not-found");
		}
	}, []);

	const goBack = () => {
		navigate(-1);
	};

	// If blog is not found, return null to prevent further rendering
	if (!isValidID) return null;

	const blogTitle = blogItem.title;
	const imgSource = blogItem.imageSource;
	const blogAlt = blogs.alt;
	// const blogDate = blogItem.datePublished;
	// const blogAuthor = blogItem.author;
	const blogIntroduction = blogItem.introduction;
	const paragraph = blogItem.description.map((par, i) => <p key={i}>{par}</p>);

	return (
		<div className="component_wrapper">
			<div className="blog_details">
				<h2>{blogTitle}</h2>
				<p className="blog_owner">
				</p>
				<div>
					<img
						src={imgSource}
						alt={blogAlt}
						width={600}
						height={338}
					/>
					<h3>{blogIntroduction}</h3>
					{paragraph}
				</div>

				<button
					className="back_btn"
					onClick={goBack}
				>
					<Undo2 /> &nbsp; Back to blogs
				</button>
			</div>
		</div>
	);
};

export default BlogDetails;
